import { useMemo } from 'react';
import { DropDownOption } from '../types';

type ReturnType = {
  extra: number;
  text: string;
};

export function useDropDownValueMultiple(
  options: DropDownOption<string>[]
): ReturnType {
  const limit = 2;

  return useMemo(() => {
    const text = options
      .slice(0, limit)
      .map((x) => x.label)
      .join(', ');

    const extra = options.length - limit > 0 ? options.length - limit : 0;

    return { text, extra };
  }, [options]);
}
